(function () {
  fetch("./assets/javascripts/featured-resources.generated.json")
    .then((response) => response.json())
    .then((data) => {
      // Use the current date as seed, as we want to keep the random values consistent between devices.
      const date = new Date();
      const seed = date.getUTCFullYear() * 365 + date.getUTCMonth() * 30 + date.getUTCDate();

      const pickedIndices = new Set();
      let attempts = 0;

      // Pick only 4 entries.
      while (pickedIndices.size < 4) {
        // Ensure the sine function produces a value between 0 and 1.
        const randomValue = (Math.sin(seed + attempts) + 1) / 2;

        // Multiply the value by data.length to get a random index between 0 and data.length-1.
        const randomIndex = Math.floor(randomValue * data.length);
        // Add only non-repeated indexes, and exclude Playgrounds, which now has a dedicated entry.
        if (!pickedIndices.has(randomIndex) && data[randomIndex].title !== "Playgrounds") {
          pickedIndices.add(randomIndex);
        }
        attempts++;
      }

      // Once we have the indices, update the DOM.
      let i = 0;
      const cardElements = document.querySelectorAll(".featured-resources .card-content:not(.card-content-playground)");
      pickedIndices.forEach((index) => {
        const item = data[index];

        // Update link.
        cardElements[i].parentNode.setAttribute("href", "resources/" + item.link);

        // Update title.
        const titleEl = cardElements[i].querySelector(".card-body h3");
        titleEl.textContent = item.title;

        // Update the description.
        const bodyEl = cardElements[i].querySelector(".card-body p");
        bodyEl.textContent = item.desc;

        // Update the image.
        const imageEl = cardElements[i].querySelector(".card-image img");
        imageEl.src = item.image;
        i++;
      });
      resizeButtonWrapper();
    })
    .catch((err) => {
      console.error("Error fetching the JSON file:", err);
    });

  /**
   * Hack to adjust the width of the `.button-wrapper` element to match the
   * furthest right pixel of its previous sibling's children.
   */
  function resizeButtonWrapper() {
    const buttonWrapper = document.querySelector(".featured-resources .button-wrapper");
    const previousSibling = buttonWrapper.previousElementSibling;

    if (buttonWrapper && previousSibling) {
      // Compute rightmost edge of all children inside previousSibling.
      let rightmostEdge = 0;
      for (const child of previousSibling.children) {
        const rect = child.getBoundingClientRect();
        const childRightEdge = rect.left + rect.width;
        if (childRightEdge > rightmostEdge) {
          rightmostEdge = childRightEdge;
        }
      }

      const wrapperLeft = buttonWrapper.getBoundingClientRect().left;
      const desiredWidth = rightmostEdge - wrapperLeft;
      buttonWrapper.style.width = `${desiredWidth}px`;
    }
  }

  window.addEventListener("resize", resizeButtonWrapper);
})();
